export const formatDateTimeParts = (value) => {
  if (value === null || value === undefined) return null;
  const text = String(value).trim();
  if (!text) return null;

  const isoMatch = text.match(
    /^(\d{4}-\d{2}-\d{2})[T\s](\d{2}:\d{2}:\d{2})(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/
  );
  if (isoMatch) {
    return {
      date: isoMatch[1],
      time: "",
    };
  }

  const [date, time] = text.split(/[T\s]/);
  if (date && time) {
    return {
      date,
      time: "",
    };
  }

  return {
    date: text,
    time: "",
  };
};
